import React, { Component } from 'react';
import _ from "lodash";
import Spinner from '../shared/spinner';
import viewHelper from '../../helpers/view';
import CONSTANTS from '../../constants';

export default class SelectSlot extends Component {

    setSlot(slot) {
        this.props.callbackToUpdateComponent({
            activity: this.props.activity,
            trainer: this.props.trainer,
            date: this.props.date,
            startTime: slot.start,
            endTime: slot.end
        })
    }

    renderSlots(slots) {
        return _.map(slots, (slot) => {
            return (
                <button key={slot.start} className='btn btn-primary slot-button' onClick={this.setSlot.bind(this, slot)}>
                    {slot.start}
                </button>
            )
        });
    }

    render () {
        const {businessHours, date} = this.props;
        if(!date) {
            // do nothing
            return '';
        } else if (date && !businessHours) {
            return <Spinner/>;
        } else {
            if (businessHours.length > 0) {
                return(
                    <div className='slots pt-15'>
                        <h4 className='no-margin pb-15'>
                            {this.props.trainer.first_name}'s Availability on {viewHelper.getFormattedDate(this.props.date, CONSTANTS.DATE.FORMAT.DEFAULT)}.
                        </h4>
                        {this.renderSlots(businessHours)}
                    </div>
                );
            } else {
                return (
                    <div className="slots pt-15">
                        <h4 className='no-margin pb-15'>
                            Sorry, {this.props.trainer.first_name}'s Not Available on {viewHelper.getFormattedDate(this.props.date, CONSTANTS.DATE.FORMAT.DEFAULT)}.
                        </h4>
                        <div className='small'>You can always select a different staff member.</div>
                    </div>
                );
            }
        }
    }
}
